import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Modal, Box, Typography, Button, TextField, Alert } from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import { useShopShow } from "queries/shops";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  maxWidth: "90%",
  boxSizing: "border-box",
  bgcolor: "background.paper",
  border: "1px solid #000",
  boxShadow: 24,
  p: 4,
};

interface AddShopModalProps {
  onClose: () => void;
}

const AddShopModal = ({ onClose }: AddShopModalProps) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const [erpId, setErpId] = useState("");
  const { isLoading, refetch: fetchShop, error } = useShopShow(erpId, { enabled: false });

  const submit = async (e: any) => {
    e.preventDefault();
    const { data: shop } = await fetchShop();
    if (!shop) return;
    navigate(`/shops/${shop.erpId}/edit`);
  };

  return (
    <Modal open onClose={onClose}>
      <Box sx={style}>
        {error && (
            <Alert severity="error">{error.response.data.detail}</Alert>
        )
        }
        <Typography id="modal-modal-title" variant="h6" component="h2">
          {t("shop.add.notice")}
        </Typography>
        <form onSubmit={submit}>
          <TextField
            required
            label={t("shop.erpId")}
            variant="standard"
            fullWidth
            onChange={(e) => setErpId(e.target.value)}
          />
          <LoadingButton loading={isLoading} variant="contained" fullWidth sx={{ mt: 2 }} type="submit">
            {t("validate")}
          </LoadingButton>
          <Button fullWidth sx={{ mt: 2 }} onClick={onClose}>
            {t("cancel")}
          </Button>
        </form>
      </Box>
    </Modal>
  );
};

export default AddShopModal;
